/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
export const SHOW_HIDE_USER_LOADER = 'SHOW_HIDE_USER_LOADER';
export const SHOW_HIDE_ROLE_ASSIGNMENT_LOADER = 'SHOW_HIDE_ROLE_ASSIGNMENT_LOADER'
export const SHOW_HIDE_BUILT_IN_POLICIES_LOADER = 'SHOW_HIDE_BUILT_IN_POLICIES_LOADER'


